/**
 * xDrop API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from "@angular/common/http";
import { CustomHttpParameterCodec } from "../encoder";
import { Observable } from "rxjs";

// @ts-ignore
import { CreateZoneDto } from "../model/createZoneDto";
// @ts-ignore
import { ZoneDto } from "../model/zoneDto";

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from "../variables";
import { Configuration } from "../configuration";

@Injectable({
  providedIn: "root",
})
export class ZonesService {
  protected basePath = "http://localhost";
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== "string") {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== "string") {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === "object" && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === "object") {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error("key may not be null if value is Date");
        }
      } else {
        Object.keys(value).forEach(
          k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)),
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error("key may not be null if value is not object or array");
    }
    return httpParams;
  }

  /**
   * Create a new zone
   * @param createZoneDto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public zoneControllerCreate(
    createZoneDto: CreateZoneDto,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<ZoneDto>;
  public zoneControllerCreate(
    createZoneDto: CreateZoneDto,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<ZoneDto>>;
  public zoneControllerCreate(
    createZoneDto: CreateZoneDto,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<ZoneDto>>;
  public zoneControllerCreate(
    createZoneDto: CreateZoneDto,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (createZoneDto === null || createZoneDto === undefined) {
      throw new Error("Required parameter createZoneDto was null or undefined when calling zoneControllerCreate.");
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential("bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set("Authorization", "Bearer " + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Accept", localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Content-Type", httpContentTypeSelected);
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/zones`;
    return this.httpClient.request<ZoneDto>("post", `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: createZoneDto,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get all zones
   * @param searchTerm Search term for the zone name
   * @param businessUnit Business unit
   * @param regionId Region ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public zoneControllerFindAll(
    searchTerm?: string,
    businessUnit?: "YACHT" | "VILLA" | "CHALET",
    regionId?: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<Array<ZoneDto>>;
  public zoneControllerFindAll(
    searchTerm?: string,
    businessUnit?: "YACHT" | "VILLA" | "CHALET",
    regionId?: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<Array<ZoneDto>>>;
  public zoneControllerFindAll(
    searchTerm?: string,
    businessUnit?: "YACHT" | "VILLA" | "CHALET",
    regionId?: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<Array<ZoneDto>>>;
  public zoneControllerFindAll(
    searchTerm?: string,
    businessUnit?: "YACHT" | "VILLA" | "CHALET",
    regionId?: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (searchTerm !== undefined && searchTerm !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchTerm, "searchTerm");
    }
    if (businessUnit !== undefined && businessUnit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>businessUnit, "businessUnit");
    }
    if (regionId !== undefined && regionId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>regionId, "regionId");
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential("bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set("Authorization", "Bearer " + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Accept", localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/zones`;
    return this.httpClient.request<Array<ZoneDto>>("get", `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get zone by ID
   * @param id Zone ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public zoneControllerFindOne(
    id: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<ZoneDto>;
  public zoneControllerFindOne(
    id: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<ZoneDto>>;
  public zoneControllerFindOne(
    id: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<ZoneDto>>;
  public zoneControllerFindOne(
    id: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error("Required parameter id was null or undefined when calling zoneControllerFindOne.");
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential("bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set("Authorization", "Bearer " + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Accept", localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/zones/${this.configuration.encodeParam({ name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined })}`;
    return this.httpClient.request<ZoneDto>("get", `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Delete zone by ID
   * @param id Zone ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public zoneControllerRemove(
    id: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public zoneControllerRemove(
    id: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public zoneControllerRemove(
    id: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public zoneControllerRemove(
    id: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error("Required parameter id was null or undefined when calling zoneControllerRemove.");
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential("bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set("Authorization", "Bearer " + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Accept", localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/zones/${this.configuration.encodeParam({ name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined })}`;
    return this.httpClient.request<any>("delete", `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Update zone by ID
   * @param id Zone ID
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public zoneControllerUpdate(
    id: string,
    body: object,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public zoneControllerUpdate(
    id: string,
    body: object,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public zoneControllerUpdate(
    id: string,
    body: object,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public zoneControllerUpdate(
    id: string,
    body: object,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error("Required parameter id was null or undefined when calling zoneControllerUpdate.");
    }
    if (body === null || body === undefined) {
      throw new Error("Required parameter body was null or undefined when calling zoneControllerUpdate.");
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential("bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set("Authorization", "Bearer " + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Accept", localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Content-Type", httpContentTypeSelected);
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/zones/${this.configuration.encodeParam({ name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined })}`;
    return this.httpClient.request<any>("patch", `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: body,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }
}
